import { PageContainer } from "@/components/common/page-container";
import { routes } from "@/constants/url";
import { UnderlineTabs, UnderlineTabsContent, UnderlineTabsList, UnderlineTabsTrigger } from "@backpac/monica";
import { Suspense } from "react";
import { useSearchParams } from "react-router";
import { BgmTerminationNotice } from "./components/bgm-termination-notice";
import { MusicMoodFilter } from "./components/music-mood-filter";
import { MusicTable } from "./components/music-table";
import { MusicPlayerBar } from "./components/player/music-player-bar";
import { MusicControlsProvider } from "./context/music-controls-context";

export function MusicPage() {
  const [searchParams, setSearchParams] = useSearchParams();

  // Check if current date is after September 30, 2025 (PT)
  const isAfterTerminationDate = () => {
    const now = new Date();
    const terminationDate = new Date("2025-09-30T23:59:59-07:00"); // September 30, 2025 11:59 PM PT
    return now > terminationDate;
  };

  const showOnlyNotice = isAfterTerminationDate();

  return (
    <MusicControlsProvider>
      <PageContainer
        nav={
          <PageContainer.Navigation
            title="Music"
            links={[
              { to: routes.MUSIC.root, text: "Library" },
              { to: routes.MUSIC.dashboard, text: "Dashboard" },
            ]}
          />
        }
      >
        <BgmTerminationNotice />
        {!showOnlyNotice && (
          <UnderlineTabs
            defaultValue={searchParams.get("favorite") ? "Favorites" : "Tracks"}
            onValueChange={(value) => {
              if (value === "Favorites") {
                setSearchParams({ favorite: "true" });
              } else {
                setSearchParams(new URLSearchParams());
              }
            }}
          >
            <UnderlineTabsList>
              <UnderlineTabsTrigger value="Tracks">Tracks</UnderlineTabsTrigger>
              <UnderlineTabsTrigger value="Favorites">Favorites</UnderlineTabsTrigger>
            </UnderlineTabsList>
            <UnderlineTabsContent value="Tracks">
              <MusicTable caption={<MusicMoodFilter />} />
            </UnderlineTabsContent>
            <UnderlineTabsContent value="Favorites">
              <MusicTable favorite={true} />
            </UnderlineTabsContent>
          </UnderlineTabs>
        )}
      </PageContainer>
      <Suspense fallback={null}>
        <MusicPlayerBar />
      </Suspense>
    </MusicControlsProvider>
  );
}
